// TODO: Remove this file after testing the PostHogProvider approach. This didn't seem to work.
// import posthog from "posthog-js";

// /**
//  * Client-side instrumentation for PostHog
//  * This function is called by Next.js when the client-side instrumentation is loaded
//  */
// export function register() {
//   // Only run on client side
//   if (typeof window === "undefined") {
//     return;
//   }

//   // Initialize PostHog on the client side
//   posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
//     api_host:
//       process.env.NEXT_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com",
//     ui_host:
//       process.env.NEXT_PUBLIC_POSTHOG_UI_HOST || "https://us.posthog.com",
//     defaults: "2025-05-24",
//     debug: process.env.NODE_ENV === "development",
//   });
// }
